import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import * as components from '../components';

export const AgilityPreset = definePreset(Aura, {
  semantic: {
    iconSize: 'var(--rem)',
    list: {
      option: {
        padding: 'var(--half-rem) var(--three-fourth-rem)',
      },
      optionGroup: {
        padding: 'var(--half-rem) var(--three-fourth-rem)',
      },
    },
    primary: {
      0: '#ffffff',
      50: '#edf4f6',
      100: '#cbe4f5',
      200: '#a8ceea',
      300: '#84b7dd',
      400: '#5e95be',
      500: '#48799d',
      600: '#376281',
      700: '#2c4d62',
      800: '#243947',
      900: '#1d272f',
      950: '#1d272f',
    },
    formField: {
      paddingX: 'var(--half-rem)',
      paddingY: 'var(--quarter-rem)',
      borderRadius: 'var(--border-radius)',
      fontSize: 'var(--font-size-body)',
      transitionDuration: '0.2s',
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'var(--focus-ring)',
      },
      sm: {
        fontSize: 'var(--font-size-body)',
      },
    },
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff',
          50: '#fafafa',
          100: '#f4f4f5',
          200: '#e4e4e7',
          300: '#d4d4d8',
          400: '#a1a1aa',
          500: '#71717a',
          600: '#52525b',
          700: '#3f3f46',
          800: '#27272a',
          900: '#18181b',
          950: '#09090b',
        },
        formField: {
          color: 'var(--p-surface-100)',
          placeholderColor: 'var(--p-surface-500)',
          borderColor: 'var(--p-surface-700)',
          hoverBorderColor: 'var(--p-primary-500)',
          focusBorderColor: 'var(--p-primary-500)',
          disabledColor: 'var(--text-color)',
          disabledBackground: 'var(--p-surface-800)',
          invalidBorderColor: 'var(--p-danger-500)',
        },
      },
      light: {
        surface: {
          0: '#ffffff',
          50: '#f5f7fb',
          100: '#eceff5',
          200: '#dee4ed',
          300: '#c8d1e1',
          400: '#b0bacd',
          500: '#8e98ac',
          600: '#707a8b',
          700: '#59606e',
          800: '#434b53',
          900: '#333940',
          950: '#333940',
        },
        formField: {
          color: 'var(--p-surface-900)',
          placeholderColor: 'var(--p-surface-300)',
          borderColor: 'var(--text-color-secondary)',
          hoverBorderColor: 'var(--p-primary-500)',
          focusBorderColor: 'var(--p-primary-500)',
          disabledColor: 'var(--text-color)',
          disabledBackground: 'var(--p-surface-100)',
          invalidBorderColor: 'var(--p-danger-500)',
        },
      },
    },
  },
  extend: {
    pink: '#df49b8',
    banner: '#d6246e',
    yellow: '#ffd800',
    black: '#000000',
    white: '#ffffff',
    success: {
      0: '#e1faeb',
      500: '#028537',
      900: '#09411e',
    },
    danger: {
      0: '#fbf0ef',
      500: '#de1a1b',
      900: '#451817',
    },
    warning: {
      0: '#fbf2e5',
      500: '#ad5f00',
      900: '#4e2f0c',
    },
  },
  components: {
    stepper: components.stepperTheme,
    accordion: components.accordionTheme,
    autocomplete: components.autocompleteTheme,
    chip: components.chipTheme,
    badge: components.badgeTheme,
    avatar: components.avatarTheme,
    carousel: components.carouselTheme,
    divider: components.dividerTheme,
    card: components.cardTheme,
    button: components.buttonTheme,
    fileupload: components.fileUploadTheme,
    dialog: components.dialogTheme,
    drawer: components.drawerTheme,
    tooltip: components.tooltipTheme,
    message: components.messageTheme,
    skeleton: components.skeletonTheme,
    datepicker: components.datePickerTheme,
    progressspinner: components.progressSpinnerTheme,
    checkbox: components.checkboxTheme,
    picklist: components.pickListTheme,
    popover: components.popoverTheme,
    radiobutton: components.radioButtonTheme,
    toast: components.toastTheme,
    menu: components.menuTheme,
    select: components.selectTheme,
    selectbutton: components.selectButtonTheme,
    togglebutton: components.toggleButtonTheme,
    toggleswitch: components.toggleSwitchTheme,
    treetable: components.treeTableTheme,
    timeline: components.timelineTheme,
    tabs: components.tabsTheme,
    datatable: components.dataTableTheme,
    multiselect: components.multiSelectTheme,
    inputgroup: components.inputGroupTheme,
  },
});
